export const globalWindow = typeof window === "undefined" ? undefined : window;
//# sourceMappingURL=global-window.js.map